import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

interface Recognition {
  id: string;
  praiser: {
    id: string;
    full_name: string;
    username: string;
    avatar_url?: string;
    belt_rank?: string;
  };
  feedback_text: string;
  created_at: string;
  techniques: Array<{
    id: number;
    name: string;
    name_br?: string | null;
  }>;
}

export const useUserRecognitions = (userId: string) => {
  return useQuery({
    queryKey: ['user-recognitions', userId],
    queryFn: async (): Promise<Recognition[]> => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) {
        throw new Error('User not authenticated')
      }

      const { data, error } = await supabase.functions.invoke('get_user_recognitions', {
        body: { target_user_id: userId }
      })

      if (error) {
        throw new Error(error.message)
      }

      return data.recognitions || []
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
} 